<div class="list-group list-group-flush settings-list-container">
    <ng-content></ng-content>
</div>
